// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"49":"e86af177","374":"cc36dcf2","381":"ff824ee0","433":"08c5ce5e","466":"dfd48023","538":"daf50592","565":"319c812a","579":"111e0aeb","644":"32a04871","736":"38a1ee3b","801":"bc26c775"}[chunkId] + ".js";
};